import React from "react";
import Card from "../../../components/Card/Card";
import List from "../../../components/List/List";
import useGetDataPaginatedList from "../../../hooks/useGetDataPaginatedList";
import ClientService from "../../../services/ClientService";
import "./ListClients.css";
import profileAvatar from "../../../assets/img/profile-avatar-gray.jpg";
import Pagination from "../../../components/Pagination/Pagination";

const ListClients = (props) => {
	const { data, columnClicked, maxPage, setColumnClicked, refetchData, isLoading } =
		useGetDataPaginatedList("clients", 1, props.filters, {
			collumnTitle: "createdAt",
			orderDirection: "DESC",
		});
	return (
		<React.Fragment>
			<div className="list-container list-visibility">
				<List
					isLoading={isLoading}
					handleCollumnTitleClick={(collumnIndex) =>
						setColumnClicked(collumnIndex)
					}
					collumsObjIndex={[
						{ collumnLabel: "Nome", index: "name", type: "text" },
						{ collumnLabel: "CPF/CNPJ", index: "document", type: "text" },
						{ collumnLabel: "Telefone", index: "phone", type: "text" },
						{
							collumnLabel: "Habilitado",
							forceLabel: true,
							index: "status",
							type: "numeric-status",
						},
					]}
					data={data}
				/>
			</div>
			<div className="card-visibility">
				{data &&
					data.map((client, index) => (
						<Card
							key={index}
							image={profileAvatar}
							delete={() => ClientService.deleteClient(client.id)}
							navigateOnDelete={"../consulta-clientes"}
							navigateOnEdit={"../cadastro-clientes"}
							data={client}
						>
							<p className="card-content-title">{client.name}</p>
							<p className="card-content">CPF: {client.document}</p>
							<p className="card-content">Telefone: {client.phone}</p>
							<p className="card-content">Email: {client.email}</p>
							<p className="card-content">Site: {client.site}</p>
							<p className="card-content">Responsável: {client.responsibles[0]?.name}</p>
							<p className="card-content">ID: {client.id}</p>
						</Card>
					))}
			</div>
			<Pagination
				rowsPerPage={8}
				maxPage={maxPage}
				changePage={(page) =>
					refetchData("clients", page, props.filters, columnClicked)
				}
			/>
		</React.Fragment>
	);
};

export default ListClients;
